// extracted by mini-css-extract-plugin
export default {"bannerRow":"TvBannerCarousel_bannerRow__aLsK3","carousel":"TvBannerCarousel_carousel__RkMSQ","track":"TvBannerCarousel_track__jgof+","banner":"TvBannerCarousel_banner__G1HeM"};